import api from '../'

const addDefaultProfilesBulkAction = (profileIds: number[]) => {
  return api.put(`administration/general/default_lms_profiles`, { lms_profile_ids: profileIds })
}

export default addDefaultProfilesBulkAction
